module.exports = __webpack_public_path__ + "fonts/371ae6baf1cbbb6aa5997156a813d2e6.txt";